module.exports = __webpack_public_path__ + "media/birth.3e140741.mp4";